import { roadmapSchema, type Roadmap } from '@mrrmlab/shared-types';
import type { HttpClient } from './http';

export type { Roadmap, RoadmapRelease } from '@mrrmlab/shared-types';

export class RoadmapResource {
  constructor(private readonly http: HttpClient) {}

  get(signal?: AbortSignal): Promise<Roadmap> {
    return this.http.request({
      method: 'GET',
      path: '/roadmap',
      responseSchema: roadmapSchema,
      signal,
    });
  }
}
